import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'dmmp-numbers-paginator',
  templateUrl: './numbers-paginator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class NumbersPaginatorComponent implements OnInit, OnChanges {
  @Input() currentPage: number
  @Input() totalPages
  @Output() selectedPage: EventEmitter<number> = new EventEmitter<number>()
  _array: number[]

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentPage ? changes.currentPage.currentValue : false) {
      this.pagination(
        changes.currentPage.currentValue,
        this.totalPages
      )
    }
    if (changes.totalPages ? changes.totalPages.currentValue : false) {
      this.pagination(
        this.currentPage,
        changes.totalPages.currentValue
      )
    }
  }

  ngOnInit(): void {
    this.pagination(this.currentPage, this.totalPages)
  }

  getRange(start, end) {
    return Array(end - start + 1)
      .fill(end - start + 1)
      .map((v, i) => i + start)
  }

  pagination(current, length, delta = 3) {
    const range = {
      start: Math.round(current - delta / 2),
      end: Math.round(current + delta / 2),
    }
    if (range.start - 1 === 1 || range.end + 1 === length) {
      range.start += 1
      range.end += 1
    }
    let pages =
      current > delta
        ? this.getRange(
        Math.min(range.start, length - delta),
        Math.min(range.end, length)
        )
        : this.getRange(1, Math.min(length, delta + 1))
    const withDots = (value, pair) =>
      pages.length + 1 !== length ? pair : [value]
    if (pages[0] !== 1) {
      pages = withDots(1, [1, '...']).concat(pages)
    }
    if (pages[pages.length - 1] < length) {
      pages = pages.concat(withDots(length, ['...', length]))
    }
    this._array = pages
  }

  nextPage() {
    this.selectedPage.emit(++this.currentPage)
  }

  backPage() {
    this.selectedPage.emit(--this.currentPage)
  }

  goToPage(item: number | string) {
    if (item !== '...') {
      this.selectedPage.emit((item as number) - 1)
    }
  }

}
